var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14.667 14.167 10.5 10M6.333 5.833 10.5 10m0 0 4.167-4.167M10.5 10l-4.167 4.167"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "images/close-icon.svg";